<template>
	<Alert type="danger">
		<template #icon>
			<IconWarning v-if="showIcon" size="lg" />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconWarning from '../icon/IconWarning.vue'
import AlertMixin from './AlertMixin.js'
export default {
	mixins: [AlertMixin],
	props: {
		showIcon: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	components: {
		Alert,
		IconWarning
	}
}
</script>
